import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/Portal/Portal.docs.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Portal, registerPortalRoot} from '@primer/react'
`}</code></pre>
    <p>{`This `}<inlineCode parentName="p">{`Portal`}</inlineCode>{` component will render all children into the portal root DOM node instead of as children of this Portal's parent DOM element. This is useful for breaking out of the current stacking context. For example, popup menus and tooltips may need to render on top of (read: covering up) other UI. The best way to guarantee this is to add these elements to top-level DOM, such as directly on `}<inlineCode parentName="p">{`document.body`}</inlineCode>{`. These elements can then be moved to the correct location using absolute positioning.`}</p>
    <Note variant="info" mdxType="Note">
      <p>{`See the `}<a parentName="p" {...{
          "href": "https://reactjs.org/docs/portals.html"
        }}>{`React documentation on portals`}</a>{` for an in-depth explanation.`}</p>
    </Note>
    <h2>{`Examples`}</h2>
    <h3>{`Default example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Portal>
  Regardless of where this appears in the React component tree, this text will be rendered in the DOM within the portal
  root at document.body.
</Portal>
`}</code></pre>
    <h3>{`Customizing the portal root`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<!-- Wherever in your DOM tree you would like to have the default portal root -->
<div id="__primerPortalRoot__"></div>
`}</code></pre>
    <p>{`or`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { registerPortalRoot } from "@primer/react"
registerPortalRoot(document.querySelector(".my-portal-root")!)
`}</code></pre>
    <p>{`By default, Primer will create a portal root for you as a child of the closest `}<inlineCode parentName="p">{`<BaseStyles>`}</inlineCode>{` element, or `}<inlineCode parentName="p">{`document.body`}</inlineCode>{` if none is found. That root will be positioned absolutely in the top-left corner of its parent element. If you would like to specify your own portal root, there are two options:`}</p>
    <ol>
      <li parentName="ol">{`Before rendering a `}<inlineCode parentName="li">{`<Portal>`}</inlineCode>{` for the first time, ensure that an element exists with id `}<inlineCode parentName="li">{`__primerPortalRoot__`}</inlineCode>{`. If that exists, it will be used as the default portal root.`}</li>
      <li parentName="ol">{`Call the `}<inlineCode parentName="li">{`registerPortalRoot`}</inlineCode>{` function, passing in the element you would like to use as your default portal root.`}</li>
    </ol>
    <p>{`Keep in mind that any inherited styles applied to portaled elements are based on its physical DOM parent. Practically this means that styles added by a `}<inlineCode parentName="p">{`<BaseStyles>`}</inlineCode>{` element will not apply to the portaled content unless the portal root is a descendent of a `}<inlineCode parentName="p">{`<BaseStyles>`}</inlineCode>{` element.`}</p>
    <p>{`Also, as `}<inlineCode parentName="p">{`<ThemeProvider>`}</inlineCode>{` affects the `}<em parentName="p">{`React`}</em>{` context, which applies to the logical React component hierarchy, the portal root is not required to be a child of a `}<inlineCode parentName="p">{`<ThemeProvider>`}</inlineCode>{` for its children to receive that context.`}</p>
    <h3>{`Multiple portal roots`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Portal, registerPortalRoot } from "@primer/react"

registerPortalRoot(document.querySelector(".scrolling-canvas-root")!, "scrolling-canvas")

// ...

export default () => (
    <Portal containerName="scrolling-canvas">
        <div>This div will be rendered into the element registered above.</div>
        <Portal>
            <div>
                This div will be rendered into the default
                portal root created at document.body
            </div>
        </Portal>
    </Portal>
)
`}</code></pre>
    <p>{`There may be situations where you want to have multiple portal roots. Advanced scenarios may necessitate multiple stacking contexts for overlays. You can set up multiple roots using the `}<inlineCode parentName="p">{`registerPortalRoot`}</inlineCode>{` function. Calling this function with an element and a string `}<inlineCode parentName="p">{`name`}</inlineCode>{` will register the root, which can then be used by creating a `}<inlineCode parentName="p">{`<Portal>`}</inlineCode>{` with a `}<inlineCode parentName="p">{`name`}</inlineCode>{` prop matching the one you registered.`}</p>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: null,
      adaptsToScreenSizes: null,
      fullTestCoverage: true,
      usedInProduction: true,
      usageExamplesDocumented: true,
      hasStorybookStories: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      